import * as React from 'react'
import LazyLoad from './LazyLoad'

interface IProps<T> {
  items: T[]
  batchSize: number
  minHeight: number
  root?: Element | null
  renderItem: (item: T, index: number) => React.ReactNode
}

const chunk = <T,>(arr: T[], size: number): T[][] =>
  Array.from({length: Math.ceil(arr.length / size)}, (_, i) =>
    arr.slice(i * size, i * size + size)
  )

const LazyLoadGroup = <T,>({items, batchSize, minHeight, root, renderItem}: IProps<T>) => {
  const batches = chunk(items, batchSize)

  return (
    <>
      {batches.map((batch, batchIndex) => (
        <LazyLoad key={batchIndex} minHeight={minHeight * batch.length} root={root}>
          {batch.map((item, itemIndex) =>
            renderItem(item, batchIndex * batchSize + itemIndex)
          )}
        </LazyLoad>
      ))}
    </>
  )
}

export default LazyLoadGroup
